export const BASIC_MODAL = 'basic';
export const WARNING_MODAL = 'warning_modal';
export const PDF_MODAL = 'pdf_modal';
export const PAYMENT_METHOD_MODAL = 'payment_method_modal';
export const PAYMENT_METHOD_PA_MODAL = 'payment_method_pa_modal';
export const RESULT_MANDATORY_MODAL = 'result_mandatory_modal';
export const KUESKI_FORM_MODAL = 'kueski_form_modal';
export const REVIEW_MODAL = 'review_modal';
export const SHARE_MODAL = 'share_modal';
export const GRATITUDE_MODAL = 'gratitude_modal';
export const TAX_SEASON_OVER_MODAL = 'tax_season_over_modal';
export const CLABE_MODAL = 'clabe_modal';
export const DG_MODAL = 'dg_modal';
export const ENTERTAIMENT_MODAL = 'ENTERTAIMENT_MODAL';
export const EFIRMA_MODAL = 'EFIRMA_MODAL';
export const INSTANT_REFUND_MODAL = 'INSTANT_REFUND_MODAL';
export const CLABE_FORM = 'CLABE_FORM';
export const TAX_SEASON_INFO = 'TAX_SEASON_INFO';
export const EFIRMA_INFO_MODAL = 'EFIRMA_INFO_MODAL';
export const EFIRMA_PREVIOUS_YEAR = 'EFIRMA_PREVIOUS_YEAR';
